import { ApplicationFormAnswers } from '../../components/ApplicationForm/ApplicationFormContext'

const hasValue = (value: unknown): boolean => {
  if (value == null) return false
  if (typeof value === 'string') return value.trim().length > 0
  return true
}

export const getMissingFields = (prefillData: ApplicationFormAnswers): Record<string, boolean> => {
  const personalDetails = prefillData?.personalDetails || {}
  const dateOfBirth = prefillData?.dateOfBirth || {}

  const fields = {
    'title': personalDetails.title,
    'firstName': personalDetails.firstName,
    'surname': personalDetails.surname,
    'maritalStatus': prefillData?.maritalStatus,
    'dateOfBirth.day': dateOfBirth.day,
    'dateOfBirth.month': dateOfBirth.month,
    'dateOfBirth.year': dateOfBirth.year,
    'contactNumber': personalDetails.contactNumber,
    'emailAddress': personalDetails.emailAddress,
    'vehicleType': prefillData?.vehicleType,
    'drivingLicence': prefillData?.drivingLicence,
    'loanAmount': prefillData?.loanAmount,
    'monthlyIncome': prefillData?.monthlyIncome
  }

  const result: Record<string, boolean> = {}
  for (const [key, value] of Object.entries(fields)) {
    result[key] = hasValue(value)
    }
    
  return result
}